import { SET_PRODUCT_INVENTORY, SET_PRODUCT_SHRINKAGE, SET_PRODUCT_VALUATION } from './constants';

export const productInventoryReducer = (state = [], action) => {
  if (action.type === SET_PRODUCT_INVENTORY) return action.payload.rows;
  return state;
};

const initialState = {
  list: [],
  summary: { totalCounted: 0, totalExpected: 0, totalShrinkageCost: 0 },
};

export const productShrinkageReducer = (state = initialState, action) => {
  if (action.type === SET_PRODUCT_SHRINKAGE) {
    return {
      list: action.payload.rows,
      summary: action.payload.summary,
    };
  }
  return state;
};

export const productValuationReducer = (state = [], action) => {
  if (action.type === SET_PRODUCT_VALUATION) return action.payload.rows;
  return state;
};
